import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
// Components
import Loading from "./components/Loading";
// Store
import store from "./redux/store";
// Styles
import "animate.css";
import "./assets/main.css";
// App
const App = React.lazy(() => import("./app"));
// Pages
const ErrorPage = React.lazy(() => import("./pages/ErrorPage"));

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<Loading />}>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route
              path={"/404"}
              render={(props: any) => <ErrorPage {...props} />}
            />
            <Route
              path={["/:key/:locale", "/:key"]}
              render={(props: any) => <App {...props} />}
            />
          </Switch>
        </Router>
      </Provider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
